import React from 'react'
import _ from 'lodash'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import Typography from '@material-ui/core/Typography'

import { Responsive } from 'react-admin'

import {
  TextField,
  NumberField,
  BooleanField,
  ReferenceField,
  DateField,
  DocumentField
} from '../Fields'
import { schemaAsFieldArray } from '../../utils/schemas'


const styles = {
    item : {
        display: 'flex',
        alignItems: 'center',
    },
    icon : {
        backgroundSize: 'cover',
        width: 20,
        height: 20,
        display: 'inline-block',
        marginRight : 5,
    },
    iconAprobado : { backgroundImage: 'url("/images/parametro_aprobado_small.png")' },
    iconEnUso : { backgroundImage: 'url("/images/parametro_en_uso_small.png")' },
    iconRechazado : { backgroundImage: 'url("/images/parametro_rechazado_small.png")' },

    cardDatasheetContainer : {
        padding : 12,
        marginBottom : 5,
        borderBottom : '1px solid #E0E0E0',
        color : '#676767'
    },
    cardDatasheetField : {
        margin: '0.5rem 0',
        display: 'flex',
        alignItems: 'center',
        '& b' : {
            color : '#019EAC',
            paddingRight : 5
        }
    }
}

const CertificationStatusField = withStyles(styles)(({ classes, cert, ...props }) => {

    let showIcon = false
    let iconClass = ""

    switch(cert){
        case 'Validado':
            showIcon = true
            iconClass = 'iconAprobado'
            break
        case 'En Uso':
            showIcon = true
            iconClass = 'iconEnUso'
            break
        case 'Rechazado':
            showIcon = true
            iconClass = 'iconRechazado'
            break
        default:
            break
    }

    return (
        <div className={classes.item}>
            {showIcon && <i className={classnames(classes.icon, classes[iconClass])}></i>}
            <span>{cert}</span>
        </div>
    )
})


const renderField = (field, datasheet) => {
    switch (field.type) {
        case "string":
            return <RenderStringField field={field} datasheet={datasheet} />
        case "number":
            return <RenderNumberField field={field} datasheet={datasheet} />
        case "boolean":
            return <RenderBooleanField field={field} datasheet={datasheet} />
        case "reference":
            return <RenderReferenceField field={field} datasheet={datasheet} />
        case "technicalData":
            return <RenderTechnicalDataField field={field} datasheet={datasheet} />
        case "date":
            return <RenderDateField field={field} datasheet={datasheet} />
        case "document":
            return <RenderDocumentField field={field} datasheet={datasheet} />
        default:
            return null
    }
}

const RenderStringField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <TextField
                            source={field.name}
                            record={datasheet}
                        />
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
                <TableRow key={`ds-${field.name}`}>
                    <TableCell align="center">{field.title}</TableCell>
                    <TableCell align="center">
                        <TextField
                            source={field.name}
                            record={datasheet}
                        />
                    </TableCell>
                    {!!field.certification && (
                        <TableCell align="center">
                            <CertificationStatusField
                                cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                            />
                        </TableCell>
                    )}
                </TableRow>
            }
        />
    )
})

const RenderNumberField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <NumberField
                            source={field.name}
                            record={datasheet}
                        />
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
        <TableRow key={`ds-${field.name}`}>
            <TableCell align="center">{field.title}</TableCell>
            <TableCell align="center">
                <NumberField
                    source={field.name}
                    record={datasheet}
                />
            </TableCell>
            {!!field.certification && (
                <TableCell align="center">
                    <CertificationStatusField
                        cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                    />
                </TableCell>
            )}
        </TableRow>
        }
        />
    )
})

const RenderBooleanField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <BooleanField
                            source={field.name}
                            record={datasheet}
                        />
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
        <TableRow key={`ds-${field.name}`}>
            <TableCell align="center">{field.title}</TableCell>
            <TableCell align="center">
                <BooleanField
                    source={field.name}
                    record={datasheet}
                />
            </TableCell>
            {!!field.certification && (
                <TableCell align="center">
                    <CertificationStatusField
                        cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                    />
                </TableCell>
            )}
        </TableRow>
        }
        />
    )
})

const RenderReferenceField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <div>
                        {_.map(field.fields, ref_field =>
                            renderField(ref_field, _.get(datasheet, field.name, {}))
                        )}
                        </div>
                    </Typography>
                    {!!field.certification &&
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>}
                </div>
            }
            medium={
        <TableRow key={`ds-${field.name}`}>
            <TableCell align="center">{field.title}</TableCell>
            <TableCell align="center">
                <Table>
                    <TableBody>
                        {_.map(field.fields, ref_field =>
                            renderField(ref_field, _.get(datasheet, field.name, {}))
                        )}
                    </TableBody>
                </Table>
            </TableCell>
            {!!field.certification && (
                <TableCell align="center">
                    <CertificationStatusField
                        cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                    />
                </TableCell>
            )}
        </TableRow>
        }
        />
    )
})

const RenderTechnicalDataField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <ReferenceField
                            source={field.name}
                            record={datasheet}
                            allowEmpty={true}
                            reference={'datos-tecnicos'}
                            basePath={"/datos-tecnicos"}
                        >
                            <TextField source="name"/>
                        </ReferenceField>
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
                <TableRow key={`ds-${field.name}`}>
                    <TableCell align="center">{field.title}</TableCell>
                    <TableCell align="center">
                        <ReferenceField
                            source={field.name}
                            record={datasheet}
                            allowEmpty={true}
                            reference={'datos-tecnicos'}
                            basePath={"/datos-tecnicos"}
                        >
                            <TextField source="name"/>
                        </ReferenceField>
                    </TableCell>
                    {!!field.certification && (
                        <TableCell align="center">
                            <CertificationStatusField
                                cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                            />
                        </TableCell>
                    )}
                </TableRow>
            }
        />
    )
})

const RenderDateField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <DateField
                            source={field.name}
                            record={datasheet}
                        />
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
                <TableRow key={`ds-${field.name}`}>
                    <TableCell align="center">{field.title}</TableCell>
                    <TableCell align="center">
                        <DateField
                            source={field.name}
                            record={datasheet}
                        />
                    </TableCell>
                    {!!field.certification && (
                        <TableCell align="center">
                            <CertificationStatusField
                                cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                            />
                        </TableCell>
                    )}
                </TableRow>
            }
        />
    )
})

const RenderDocumentField = withStyles(styles)(({ classes, field, datasheet, ...props }) => {
    return (
        <Responsive
            xsmall={
                <div key={`ds-${field.name}`} className={classes.cardDatasheetContainer}>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Dato Técnico : </b> {field.title}
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Valor : </b>
                        <DocumentField source={field.name} record={datasheet} />
                    </Typography>
                    <Typography className={classes.cardDatasheetField} >
                        <b>Certificación : </b>
                        <CertificationStatusField
                            cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                        />
                    </Typography>
                </div>
            }
            medium={
                <TableRow key={`ds-${field.name}`}>
                    <TableCell align="center">{field.title}</TableCell>
                    <TableCell align="center">
                        <DocumentField source={field.name} record={datasheet} />
                    </TableCell>
                    {!!field.certification && (
                        <TableCell align="center">
                            <CertificationStatusField
                                cert={_.get(datasheet, `ESTADO_CERTIFICACION.${field.name}`, 'No Revisado')}
                            />
                        </TableCell>
                    )}
                </TableRow>
            }
        />
    )
})

export const renderDatasheetFields = (schema, datasheet) => {
    const fields = schemaAsFieldArray(schema)
    return _.map(fields, field => renderField(field, datasheet))
}
